/**
 * 企业 签署套餐使用统计
 */

import ApiPort from '../config/api-port';
import GlobalConfig from '../config/global';
import HttpAxios from './http-axios';
import { handleError, handleResponse } from "../lib/common";

const junziqianApi = GlobalConfig.domain.junziqianApi

export default {

  /**
   * 套餐使用量新
   * @returns {Promise<T>}
   */
  currentPkgUsedInfo () {
    let url = junziqianApi + ApiPort.entPackageStat.currentPkgUsedInfo;

    return HttpAxios.post(url, {})
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 套餐使用量旧
   * @returns {Promise<T>}
   */
  pkgUse () {
    let url = junziqianApi + ApiPort.entPackageStat.pakUse;

    return HttpAxios.post(url, {})
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 签署状态统计
   * @returns {Promise<T>}
   */
  signStatus () {
    let url = junziqianApi + ApiPort.entPackageStat.signStatus;

    return HttpAxios.post(url, {})
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 签署统计按月
   * @returns {Promise<T>}
   */
  signByMonth () {
    let url = junziqianApi + ApiPort.entPackageStat.signByMonth;

    return HttpAxios.post(url, {})
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 签署按天统计
   * @returns {Promise<T>}
   */
  signByDay () {
    let url = junziqianApi + ApiPort.entPackageStat.signByDay;

    return HttpAxios.post(url, {})
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 套餐使用按天统计
   * @returns {Promise<T>}
   */
  pkgUseByDay () {
    let url = junziqianApi + ApiPort.entPackageStat.pkgUseByDay;

    return HttpAxios.post(url, {})
      .then(handleResponse)
      .catch(handleError);
  },

  pkgUseByMonth () {
    let url = junziqianApi + ApiPort.entPackageStat.pkgUseByMonth;

    return HttpAxios.post(url, {})
      .then(handleResponse)
      .catch(handleError)
  },

  // 20210302 签署统计改版
  /**
   * 用户当前可用套餐
   * @returns {Promise<T>}
   */
  queryUseAblePkgList (data) {
    let url = junziqianApi + ApiPort.entPackageStat.queryUseAblePkgList;

    return HttpAxios.post(url, data)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 用户历史过期套餐
   * @returns {Promise<T>}
   */
  queryHistoryPkgList (data) {
    let url = junziqianApi + ApiPort.entPackageStat.queryHistoryPkgList;

    return HttpAxios.post(url, data)
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 按日查询套餐项用量
   * @params{
   * assetItemId:套餐项ID
   * startDate:开始时间
   * endDate:结束时间
   * itemPage:页数
   * pageSize:页长
   * }
   * @returns {Promise<T>}
   */
  queryAssetItemDayUsed ({ assetItemId, startDate, endDate, itemPage, pageSize }) {
    let url = junziqianApi + ApiPort.entPackageStat.queryAssetItemDayUsed;

    return HttpAxios.post(url, { assetItemId, startDate, endDate, itemPage, pageSize })
      .then(handleResponse)
      .catch(handleError);
  },

  /**
   * 按日查询套餐项用量
   * @params{
   * assetItemId:套餐项ID
   * startDate:开始时间(dateType不传则必填)
   * endDate:结束时间(dateType不传则必填)
   * dateType:1:7天,2:30天,3:90天(不包含当天)
   * corpQuery 1 成员查询企业
   * }
   * @returns {Promise<T>}
   */
  queryAssetItemDayUsedFillZero ({ assetItemId, startDate = '', endDate = '', dateType, corpQuery }) {
    let url = junziqianApi + ApiPort.entPackageStat.queryAssetItemDayUsedFillZero;
    const data = { assetItemId, startDate, endDate, dateType }
    if (corpQuery) data.corpQuery = corpQuery
    return HttpAxios.post(url, data)
      .then(handleResponse)
      .catch(handleError);
  },
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/entPackageStat.js